import image, { CATEGORY_BANNER_BIG } from "lacinetek-common/src/images"

import { useTranslation } from "lib/i18n/translation"

import Image from "components/common/image"

const Header = ({ selection, loading }) => {
	const { c } = useTranslation("common")

	return (
		<section className={`focus has-splitted black${loading ? " skel-loading" : ""}`}>
			<div className="splitted invert">
				<figure>
					<picture>
						<Image src={image(selection, CATEGORY_BANNER_BIG)} alt={c(selection.name)} />
					</picture>
				</figure>
				<div className="content">
					<h1 className="title-alt skel">{c("focus-on")}<br /><strong>{c(selection.name)}</strong></h1>
					<div className="description skel" dangerouslySetInnerHTML={{ __html: selection.description }} />
				</div>
			</div>
		</section>
	)
}

export default Header
